import { createContext, useContext } from 'react';
export const LowLevelAuthFlowMachineContext = /*#__PURE__*/createContext(null);
export function useLowLevelAuthFlowMachine() {
  const machine = useContext(LowLevelAuthFlowMachineContext);
  if (!machine) {
    throw new Error('useLowLevelAuthFlowMachine must be used within a LowLevelAuthFlowMachineContext.Provider');
  }
  return machine;
}